// New value lists are saved with a `Z_tbl` prefix (see FormValueList/index.jsx onSaveDrawer).
// Backend limit: 50 chars for the persisted technical name.
export const VALUE_LIST_NAME_MAX_LENGTH = 45;
export const VALUE_LIST_PERSISTED_TECHNICAL_NAME_MAX_LENGTH =
    VALUE_LIST_NAME_MAX_LENGTH + 'Z_tbl'.length;

export const getValueListFormProperties = ({ allowPersistedTechnicalName = false } = {}) => ({
    apiNameV4: {
        readOnly: true,
    },
    name: {
        maxLength: allowPersistedTechnicalName
            ? VALUE_LIST_PERSISTED_TECHNICAL_NAME_MAX_LENGTH
            : VALUE_LIST_NAME_MAX_LENGTH,
        type: ['string'],
    },
    description: {
        maxLength: VALUE_LIST_NAME_MAX_LENGTH,
        type: ['string'],
    },
    isEditable: {
        type: ['boolean'],
        default: true,
    },
    integrationField: {
        type: ['integer'],
    },
});

export const VALUE_LIST_FORM_PROPERTIES = getValueListFormProperties();
